import { translationMessages, configuratorType } from '../i18n';

export default {  
  event: function (label, action, category) {
    let trackingConfType = configuratorType === 'water' ? 'Watersystem' : 'Showersystem';
    const newLabel = translationMessages.en[label];
    if (!newLabel) {
      console.log('could not translate', label); // eslint-disable-line no-console
    }
    // eslint-disable-next-line no-undef
    dataLayer.push({
      'event': 'event',
      'eventCategory': category ? category :  trackingConfType + ' Configurator',
      'eventAction': action ? action : '',
      'eventLabel': newLabel ? newLabel : label
    });
  },
  page: function (url) {
    // eslint-disable-next-line no-undef
    dataLayer.push({
      'event': 'page',
      'pageName': url
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/Tracking.js